import { createAction, props } from '@ngrx/store';
import {
  APIKey,
  CreateAPIKeyRequest,
  CreateAPIKeyResponse,
  UpdateAPIKeyRequest,
  RevokeAPIKeyRequest,
  RotateAPIKeyRequest,
  RotateAPIKeyResponse,
  ListAPIKeysResponse,
  APIKeyFilters,
  APIKeyUsageStats
} from '../models/api-key.models';

/**
 * API Keys Actions
 */

// Load API Keys List
export const loadApiKeys = createAction(
  '[API Keys] Load API Keys',
  props<{ filters: APIKeyFilters }>()
);

export const loadApiKeysSuccess = createAction(
  '[API Keys] Load API Keys Success',
  props<{ data: ListAPIKeysResponse }>()
);

export const loadApiKeysFailure = createAction(
  '[API Keys] Load API Keys Failure',
  props<{ error: string }>()
);

// Load Single API Key
export const loadApiKey = createAction(
  '[API Keys] Load API Key',
  props<{ keyId: string }>()
);

export const loadApiKeySuccess = createAction(
  '[API Keys] Load API Key Success',
  props<{ apiKey: APIKey }>()
);

export const loadApiKeyFailure = createAction(
  '[API Keys] Load API Key Failure',
  props<{ error: string }>()
);

// Create API Key
export const createApiKey = createAction(
  '[API Keys] Create API Key',
  props<{ request: CreateAPIKeyRequest }>()
);

export const createApiKeySuccess = createAction(
  '[API Keys] Create API Key Success',
  props<{ response: CreateAPIKeyResponse }>()
);

export const createApiKeyFailure = createAction(
  '[API Keys] Create API Key Failure',
  props<{ error: string }>()
);

// Update API Key
export const updateApiKey = createAction(
  '[API Keys] Update API Key',
  props<{ keyId: string; request: UpdateAPIKeyRequest }>()
);

export const updateApiKeySuccess = createAction(
  '[API Keys] Update API Key Success',
  props<{ apiKey: APIKey }>()
);

export const updateApiKeyFailure = createAction(
  '[API Keys] Update API Key Failure',
  props<{ error: string }>()
);

// Revoke API Key
export const revokeApiKey = createAction(
  '[API Keys] Revoke API Key',
  props<{ keyId: string; request?: RevokeAPIKeyRequest }>()
);

export const revokeApiKeySuccess = createAction(
  '[API Keys] Revoke API Key Success',
  props<{ keyId: string }>()
);

export const revokeApiKeyFailure = createAction(
  '[API Keys] Revoke API Key Failure',
  props<{ error: string }>()
);

// Delete API Key (Permanent)
export const deleteApiKey = createAction(
  '[API Keys] Delete API Key',
  props<{ keyId: string }>()
);

export const deleteApiKeySuccess = createAction(
  '[API Keys] Delete API Key Success',
  props<{ keyId: string }>()
);

export const deleteApiKeyFailure = createAction(
  '[API Keys] Delete API Key Failure',
  props<{ error: string }>()
);

// Regenerate API Key
export const regenerateApiKey = createAction(
  '[API Keys] Regenerate API Key',
  props<{ keyId: string }>()
);

export const regenerateApiKeySuccess = createAction(
  '[API Keys] Regenerate API Key Success',
  props<{ response: CreateAPIKeyResponse }>()
);

export const regenerateApiKeyFailure = createAction(
  '[API Keys] Regenerate API Key Failure',
  props<{ error: string }>()
);

// Rotate API Key
export const rotateApiKey = createAction(
  '[API Keys] Rotate API Key',
  props<{ keyId: string; request?: RotateAPIKeyRequest }>()
);

export const rotateApiKeySuccess = createAction(
  '[API Keys] Rotate API Key Success',
  props<{ response: RotateAPIKeyResponse }>()
);

export const rotateApiKeyFailure = createAction(
  '[API Keys] Rotate API Key Failure',
  props<{ error: string }>()
);

// Load API Key Usage Stats
export const loadApiKeyUsageStats = createAction(
  '[API Keys] Load API Key Usage Stats',
  props<{ keyId: string }>()
);

export const loadApiKeyUsageStatsSuccess = createAction(
  '[API Keys] Load API Key Usage Stats Success',
  props<{ stats: APIKeyUsageStats }>()
);

export const loadApiKeyUsageStatsFailure = createAction(
  '[API Keys] Load API Key Usage Stats Failure',
  props<{ error: string }>()
);

// Update Filters
export const updateFilters = createAction(
  '[API Keys] Update Filters',
  props<{ filters: Partial<APIKeyFilters> }>()
);

// Clear State
export const clearApiKeys = createAction(
  '[API Keys] Clear API Keys'
);

export const clearSelectedApiKey = createAction(
  '[API Keys] Clear Selected API Key'
);

export const clearNewlyCreatedKey = createAction(
  '[API Keys] Clear Newly Created Key'
);

export const clearRotatedKey = createAction(
  '[API Keys] Clear Rotated Key'
);

